import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ResponseInfo from '../UI/ResponseInfo';
import TableComponent from '../UI/tableComponent';
import { URL_CONFIG } from '../constants/rest-config';
import { pageLoaderHandler } from '../helpers';
import { httpHandler } from '../http/http-interceptor';
import { BreadCrumbActions } from '../store/breadcrumb-slice';
import TypeBasedFilter from '../UI/TypeBasedFilter';
import { TYPE_BASED_FILTER } from '../constants/ui-config';
import PageHeader from '../UI/PageHeader';
const ActivityLogs = () => {
  const dispatch = useDispatch();

  const userRolePermission = useSelector(
    (state) => state.sharedData.userRolePermission,
  );

  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [filterParams, setFilterParams] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  });
  const breadcrumbArr = [
    {
      label: 'Home',
      link: 'app/dashboard',
    },
    {
      label: 'Admin Panel',
      link: 'app/adminpanel',
    },
    {
      label: 'Activity Logs',
      link: '',
    },
  ];

  useEffect(() => {
    dispatch(
      BreadCrumbActions.updateBreadCrumb({
        breadcrumbArr,
        title: 'Activity Logs',
      }),
    );
  }, [dispatch]);

  //   const fetchActivityLogs = () => {
  //     setIsLoading(true);

  //     const obj = {
  //       url: URL_CONFIG.GET_ACTIVITY_LOGS,
  //       method: 'get',
  //     };

  //     httpHandler(obj)
  //       .then((response) => {
  //         console.log('Activity Logs API Response:', response);

  //         setLogs(response?.data?.data ?? []);
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log('Activity Logs Error:', error);
  //         setIsLoading(false);
  //       });
  //   };
  const fetchActivityLogs = (paramsInfo) => {
    setIsLoading(true);

    let obj = {
      url: URL_CONFIG.GET_ACTIVITY_LOGS,
      method: 'get',
      params: paramsInfo,
    };

    httpHandler(obj)
      .then((response) => {
        setLogs(response?.data?.data ?? []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log('Activity Logs Error:', error);
        setIsLoading(false);
      });
  };
  //   useEffect(() => {
  //     fetchActivityLogs();
  //   }, []);
  useEffect(() => {
    fetchActivityLogs(filterParams);
  }, []);
  useEffect(() => {
    pageLoaderHandler(isLoading ? 'show' : 'hide');
  }, [isLoading]);
  const getFilterParams = (paramsData) => {
    setFilterParams({ ...paramsData });
    fetchActivityLogs(paramsData);
  };
  const activityLogHeaders = [
    // {
    //   header: 'User Name',
    //   accessorFn: (row) =>
    //     `${row?.users?.first_name || ''} ${row?.users?.last_name || ''}`,
    // },
    // {
    //   header: 'Email',
    //   accessorFn: (row) => row?.users?.email || '-',
    // },
    // {
    //   header: 'Activity',
    //   accessorKey: 'type',
    // },
    // {
    //   header: 'Description',
    //   accessorKey: 'description',
    // },
    // {
    //   header: 'Date & Time',
    //   accessorFn: (row) =>
    //     row?.created_at ? new Date(row.created_at).toLocaleString() : '-',
    // },
    {
      header: 'User Name',
      accessorFn: (row) => row?.description || '-',
    },
    {
      header: 'Email',
      accessorFn: (row) => row?.users?.email || '-',
    },
    {
      header: 'Activity',
      accessorKey: 'type',
    },
    {
      header: 'Date & Time',
      accessorFn: (row) =>
        row?.created_at ? new Date(row.created_at).toLocaleString() : '-',
    },
  ];

  return (
    <>
      <PageHeader
        title="Activity Logs"
        filter={
          <TypeBasedFilter
            config={TYPE_BASED_FILTER}
            getFilterParams={getFilterParams}
          />
        }
      />
      {userRolePermission?.adminPanel && (
        <TableComponent
          data={logs ?? []}
          columns={activityLogHeaders}
          actionHidden={true}
        />
      )}

      {!userRolePermission?.adminPanel && (
        <div className="row eep-content-section-data no-gutters">
          <ResponseInfo
            title="Oops! Looks illegal way."
            responseImg="accessDenied"
            responseClass="response-info"
            messageInfo="Contact Administrator."
          />
        </div>
      )}
    </>
  );
};

export default ActivityLogs;
